<div class="twc-d-flex project-selection-text">
    <h2 class="twc-h2">{{'CREATE_PROJECT.SELECT_EXISTING' | translate}}</h2>
</div>

<div class="height-100">
    <cw-object-browser class="select-project-browser"  [browserViews]="browserViews" [data]="currentData$ | async" [loading]="loading"
        [shouldShowCheckboxes]="hasToShowCheckbox" dataType="projects"
        [pagination]="pagination" (filterChange)="filterChanged($event)" (pageChange)="pageChanged($event)"
        (dataRefresh)="dataRefreshed()">
    </cw-object-browser>
</div>